/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Permissions_Is_DefaultInputs */

const en_tables_permissions_is_default = /** @type {(inputs: Tables_Permissions_Is_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Default`)
};

const de_tables_permissions_is_default = /** @type {(inputs: Tables_Permissions_Is_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Standard`)
};

/**
* | output |
* | --- |
* | "Is Default" |
*
* @param {Tables_Permissions_Is_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_permissions_is_default = /** @type {((inputs?: Tables_Permissions_Is_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Permissions_Is_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_permissions_is_default(inputs)
	return de_tables_permissions_is_default(inputs)
});